import { render, staticRenderFns } from "./FeaturedServicesDataWrapper.vue?vue&type=template&id=2c11ca18&scoped=true&"
import script from "./FeaturedServicesDataWrapper.vue?vue&type=script&lang=js&"
export * from "./FeaturedServicesDataWrapper.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./FeaturedServicesDataWrapper.vue?vue&type=style&index=0&id=2c11ca18&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2c11ca18",
  "301dad68"
  
)

export default component.exports